import {
  Button,
  Col,
  Collapse,
  Divider,
  Empty,
  Form,
  Input,
  InputNumber,
  message,
  Popover,
  Select,
  Space,
  Spin,
} from 'antd'
import styles from './index.module.less'
import { SDrawerOrModal, SGeneralForms, SSegmentedTabs, STitle } from 'shj-components'
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { cloneDeep, isArray } from 'lodash-es'
import {
  changeBaseInfo,
  getCalcQuoteBudgetPrice,
  getCapitalPool,
  getConfigurations,
  quoteBudgetPriceQueryTree,
  refreshQuoteBudgetPrice,
  selectMainSpaceSpec,
} from '@/services/order'
import { useParams } from 'react-router-dom'
import { numFormat } from 'shj-components/dist/es/SFilterTable'
import { OrderEdit } from '@/components/icons'
import PoolingTable from './PoolingTable'
import ConfigPriceList from './ConfigPriceList'
import { FormOutlined } from '@ant-design/icons'
const { Panel } = Collapse
const classNameObj = {
  工程总造价: 'total-project-cost',
  优惠汇总: 'offer-summary',
  合同金额: 'contract-amount',
  其他收款项目: 'other-income-items',
}

export default forwardRef(function BudgetPrice(props: any, ref) {
  const { couldEdit, quoteBudgetInfo, priceTabList } = props
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [treeData, setTreeData] = useState<any>([])
  const [couldOperate, setCouldOperate] = useState(true)
  const [budgetId, setBudgetId] = useState(useParams()?.budgetId || '')
  const [editFlag, setEditFlag] = useState(false)
  const timeout = useRef<any>(null)
  const [skuArgList, setSkuArgList] = useState<any>([])
  const [btnLoding, setBtnLoding] = useState(false)
  const [spaceArgList, setSpaceArgList] = useState<any>([])
  const [form] = Form.useForm()
  // 资金池
  const [poolingOpen, setPoolingOpen] = useState(false)
  const [poolingOpenLoading, setPoolingOpenLoading] = useState(false)
  const [poolingData, setPoolingData] = useState<any>([])
  const [priceTabvalue, setPriceTabvalue] = useState('1')
  const [priceListData, setPriceListData] = useState<any>([])
  const [lastFormValue, setLastFormValue] = useState({});
  const handlebaseInfo = async () => {
    if (quoteBudgetInfo?.skuArgJson) {
      let skuArgList = JSON.parse(quoteBudgetInfo?.skuArgJson || '[]')
      // skuArgList = skuArgList?.filter(item => !item.addFlag)
      console.log(skuArgList, 'skuArgList')

      setSkuArgList(skuArgList)
      let roomNum = 0
      let toiletNum = 0
      skuArgList.forEach((arg: any) => {
        if (arg.argCode === 'BED_ROOM' && Number(arg.argVal) !== NaN) {
          roomNum = Number(arg.argVal)
        }
        if (arg.argCode === 'toilet_num' && Number(arg.argVal) !== NaN) {
          toiletNum = Number(arg.argVal)
        }
      })
      const res = await selectMainSpaceSpec({
        quoteBudgetId: budgetId,
        roomNum,
        toiletNum,
      })
      if (Array.isArray(res)) {
        setSpaceArgList(res)
        form.setFieldValue('spaceQuoteBudgetItemList', res)
      }
    }
  }
  useEffect(() => {
    handlebaseInfo()
  }, [quoteBudgetInfo])

  useEffect(() => {
    if (open && skuArgList?.length) {
      handlebaseInfo()
    }
    if (!open) {
      form.resetFields()
    }
  }, [open])

  // 1. 初始化
  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    setCouldOperate(couldEdit)
  }, [couldEdit])

  useImperativeHandle(
    ref,
    () => ({
      init: () => init(),
    }),
    []
  )

  const init = (id?: string) => {
    setLoading(true)
    quoteBudgetPriceQueryTree({
      params: {
        quoteBudgetId: id || budgetId,
      },
    })
      .then((res: any) => {
        if (isArray(res)) {
          setTreeData([...res])
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  // 根据id,更新价格
  const updateTreeById = (tree, id, newData) => {
    return tree.map(node => {
      if (node.id === id) {
        return { ...node, object: { ...node.object, ...newData } }
      }
      if (node.children) {
        const updatedChildren = updateTreeById(node.children, id, newData)
        return { ...node, children: updatedChildren }
      }
      return node
    })
  }

  const limitDecimals = value => {
    const reg = /^(\-)*(\d+)\.(\d\d).*$/
    return String(value).replace(reg, '$1$2.$3')
  }

  // 查询价格
  const debouncedSetValue = (treeEntityQuoteBudgetPriceTreeLongs, item) => {
    setLoading(true)
    getCalcQuoteBudgetPrice({
      params: {
        quoteBudgetId: budgetId,
      },
      data: treeEntityQuoteBudgetPriceTreeLongs,
    })
      .then(res => {
        setTreeData(res || [])
      })
      .finally(() => {
        setLoading(false)
      })
  }
  // 改变价格
  const changePrice = (newValue, item) => {
    const valueInput = limitDecimals(newValue)
    const treeEntityQuoteBudgetPriceTreeLongs = updateTreeById(treeData, item.id, {
      price: valueInput || '',
      editedFlag: true,
    })
    setTreeData(treeEntityQuoteBudgetPriceTreeLongs || [])
    if (timeout?.current) {
      clearTimeout(timeout?.current)
    }
    timeout.current = setTimeout(() => {
      debouncedSetValue(treeEntityQuoteBudgetPriceTreeLongs, item)
    }, 1500)
  }
  // 编辑框
  const renderEditInput = it => {
    // editFlag 是否处于编辑状态
    if (validateShowBtnFn(it) && editFlag) {
      return (
        <InputNumber
          step="0.01"
          type="number"
          formatter={limitDecimals}
          parser={limitDecimals}
          onInput={e => {
            changePrice(e, it)
          }}
          size="small"
          value={it?.object?.price}
          prefix="￥"
          style={{ width: 120 }}
          onClick={e => {
            e.stopPropagation()
          }}
        />
      )
    }
    return (
      <div
        className={`${styles.price} ${
          [
            'TOTAL_PROJECT_COST',
            'CONTRACT_AMOUNT',
            'DISCOUNT_SUMMARY',
            'OTHER_PAYMENT_ITEMS',
          ].includes(it?.object?.type)
            ? styles.redPrice
            : ''
        }`}
      >
        ￥{it?.object?.price ? `${numFormat({ value: it?.object?.price })}` : '0.00'}
      </div>
    )
  }
  // 渲染列表
  const renderItem = (item, index) => {
    return (
      <div className={styles.header}>
        <Popover content={item?.object?.name} placement="topLeft">
          <div className={styles.label}>
            {item.parentId !== '0' && <span className={styles.numberIndex}>{index + 1}</span>}
            {item?.object?.name}
          </div>
        </Popover>
        {renderEditInput(item)}
      </div>
    )
  }
  // 验证是否可编辑
  const validateShowBtnFn = node =>
    (node?.object?.mathType === 'CREATOR_ENTRY' || node?.object?.editFlag) && couldOperate

  // 验证
  const isEmpty = value => {
    return value === null || value === undefined || value === ''
  }
  // 验证未填写
  const validateFn = node => validateShowBtnFn(node) && isEmpty(node?.object?.price)
  const validateTree = (tree, validateFn) => {
    for (const node of tree) {
      if (validateFn(node)) {
        return {
          label: node?.label,
          status: false,
        } // 如果验证失败，返回false
      }
      if (node.children && node.children.length > 0) {
        const result = validateTree(node.children, validateFn).status
        if (!result) {
          return {
            label: node?.label,
            status: false,
          } // 如果子节点验证失败，返回false
        }
      }
    }
    return {
      label: '',
      status: true,
    } // 所有节点验证通过，返回true
  }
  // 点击保存
  const saveFn = () => {
    if (!validateTree(treeData, validateFn).status) {
      return message.error(`请填写${validateTree(treeData, validateFn)?.label}！`)
    }
    setLoading(true)
    refreshQuoteBudgetPrice({
      params: {
        quoteBudgetId: budgetId,
      },
      data: treeData,
    })
      .then(() => {
        init()
        setEditFlag(false)
        // props?.onCancel && props?.onCancel()
        props?.reloadList && props?.reloadList()
      })
      .finally(() => {
        setLoading(false)
      })
  }
  const renderTreeComponent = (treeData, level) => {
    return (
      <div>
        {(treeData || []).map((item, index) => {
          if ((item?.children || []).length === 0) {
            return (
              <>
                <div
                  className={`${styles.noSubHeader} ${level === 0 ? styles.levelFirst : ''}  ${
                    level === 0 && classNameObj[item.label] ? classNameObj[item.label] : ''
                  } 
                  ${!item.object.type ? 'normalFee' : ''} `}
                  key={item?.id}
                >
                  {renderItem(item, index)}
                </div>
              </>
            )
          }
          return (
            <Collapse
              ghost
              defaultActiveKey={['1']}
              className={`${classNameObj[item.label] ? classNameObj[item.label] : ''}  ${
                !item.object.type ? 'normalFee' : ''
              } `}
            >
              <Panel
                header={
                  <div className={`${level === 0 ? styles.levelFirst : ''}  `}>
                    {renderItem(item, index)}
                  </div>
                }
                key={'1'}
              >
                {renderTreeComponent(item?.children, level + 1)}
              </Panel>
            </Collapse>
          )
        })}
      </div>
    )
  }
  const clickToOpen = () => {
    setOpen(true)
  }
  const onSubmit = () => {
    form.validateFields().then(values => {
      setBtnLoding(true)
      let newSkuArgList: any = cloneDeep(skuArgList)
      newSkuArgList.forEach((item: any) => {
        if (values[item.argCode]) {
          item.argVal = values[item.argCode]
        }
      })
      changeBaseInfo({
        data: {
          budgetId: budgetId,
          skuArgJsonList: newSkuArgList,
          spaceQuoteBudgetItemList: values.spaceQuoteBudgetItemList,
        },
      })
        .then(() => {
          setOpen(false)
          setBtnLoding(false)
          setSkuArgList(newSkuArgList)
          init()
          props?.reloadList && props?.reloadList()
          message.success('修改成功')
        })
        .catch(() => {
          setBtnLoding(false)
        })
    })
  }

  const clickToEdit = () => {
    console.log('clickToEdit')
    setEditFlag(true)
    renderTreeComponent(treeData, 0)
  }

  const handleShow = () => {
    let flag = skuArgList.some((item: any) => item.argType === 'INPUT')
    return flag
  }
  const spaceChange = (changedValues, allValues) => {
    const argCodeList = skuArgList?.map((item: any) => item.argCode)
    if (changedValues && !argCodeList?.includes(Object.keys(changedValues)?.[0])) {
      setLastFormValue(allValues);
      return
    }
    let roomNum: any = 0
    let toiletNum: any = 0
    skuArgList.forEach((arg: any) => {
      if (arg.argCode === 'BED_ROOM' && Number(allValues['BED_ROOM']) !== NaN) {
        roomNum = allValues['BED_ROOM'] ? Number(allValues['BED_ROOM']) : ''
      }
      if (arg.argCode === 'toilet_num' && Number(allValues['toilet_num']) !== NaN) {
        toiletNum = allValues['toilet_num'] ? Number(allValues['toilet_num']) : ''
      }
    })
    if (roomNum !== '' && toiletNum !== '') {
      selectMainSpaceSpec({
        quoteBudgetId: budgetId,
        roomNum,
        toiletNum,
      }).then(res => {
        if (Array.isArray(res)) {
          setSpaceArgList(res)
          console.log(res, 'res')
          form.setFieldValue('spaceQuoteBudgetItemList', res)
        }
        setLastFormValue(form.getFieldsValue());
      }).catch(() => {
        if (Object.keys(changedValues || {})?.[0]) {
          form.setFieldValue(Object.keys(changedValues || {})?.[0], lastFormValue?.[Object.keys(changedValues || {})?.[0]]);
        }
      })
    } else {
      setLastFormValue(allValues);
    }
  }
  const clickToGetPoolingTable = () => {
    setPoolingOpen(true)
    setPoolingOpenLoading(true)
    getCapitalPool(budgetId)
      .then((res: any) => {
        setPoolingData(res)
      })
      .finally(() => {
        setPoolingOpenLoading(false)
      })
  }
  const priceTabListChange = value => {
    setPriceTabvalue(value)
    if (value === '2') {
      // 获取清单数据
      getConfigurations(budgetId).then(res => {
        console.log(res, '清单数据')
        if (res && Array.isArray(res)) {
          setPriceListData(res)
        }
      })
    }
  }
  return (
    <div className={styles.budgetPriceBox}>
      <div className={styles.baseTopBox}>
        <div
          style={{
            display: 'flex',
            alignItems: 'left',
            flexDirection: 'column',
            justifyContent: 'left',
          }}
        >
          {handleShow() ? (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>
              <span className={styles.titleName}>基本信息</span>
              <Space split={<Divider type="vertical" />} style={{ marginRight: 30 }}>
                {skuArgList.map((item: any) => {
                  if (item?.argType === 'INPUT'&&!item?.addFlag) {
                    return (
                      <span>
                        {item?.argName}：{item?.argVal}
                      </span>
                    )
                  }
                })}
              </Space>
              {quoteBudgetInfo?.state === 'budgetDraft' && !quoteBudgetInfo?.frozenFlag && (
                // <OrderEdit style={{ cursor: 'pointer'}} onClick={clickToOpen}></OrderEdit>
                <FormOutlined  onClick={clickToOpen} style={{color:'#0053cf'}} />
                
              )}
            </div>
          ) : null}
          {quoteBudgetInfo?.spaceQuoteBudgetItemList?.filter(item => item.spaceSpecParamValueId)
            ?.length ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'left',
                marginTop: '20px',
              }}
            >
              <span className={styles.titleName}>空间规格</span>
              <Space wrap split={<Divider type="vertical" />}>
                {quoteBudgetInfo?.spaceQuoteBudgetItemList
                  ?.filter(item => item.spaceSpecParamValueId)
                  ?.map(item => (
                    <span>
                      {item?.showName}：{item?.spaceSpecParamValueName}
                    </span>
                  ))}
              </Space>
            </div>
          ) : null}
        </div>
      </div>
      <div className={styles.priceBox}>
        {/* 预算信息 */}
        <Spin spinning={loading}>
          {(treeData || []).length > 0 ? (
            <div className={styles.priceDetailBox}>
              <div className={styles.priceTabBox}>
                <SSegmentedTabs
                  options={priceTabList}
                  value={priceTabvalue}
                  onChange={priceTabListChange}
                />
                {priceTabvalue === '1' ? (
                  <div className={styles.modifyBtnBox}>
                    {priceTabList?.length > 0 && (
                      <Button type="link" onClick={clickToGetPoolingTable}>
                        资金池详情
                      </Button>
                    )}
                    {editFlag ? (
                      <div className={styles.btnBox}>
                        <Button
                          size="small"
                          onClick={() => {
                            setEditFlag(false)
                            // props?.onCancel()
                          }}
                          style={{ marginRight: 10 }}
                        >
                          取消
                        </Button>
                        <Button type="primary" size="small" onClick={saveFn}>
                          保存
                        </Button>
                      </div>
                    ) : (
                      <Button
                        onClick={clickToEdit}
                        disabled={
                          !(
                            quoteBudgetInfo?.state === 'budgetDraft' && !quoteBudgetInfo?.frozenFlag
                          )
                        }
                        type="link"
                        ghost
                      >
                        编辑金额
                      </Button>
                    )}
                  </div>
                ) : null}
              </div>
              {priceTabvalue === '1' ? (
                <div className={styles.priceList}>{renderTreeComponent(treeData, 0)}</div>
              ) : (
                <ConfigPriceList data={priceListData}></ConfigPriceList>
              )}
            </div>
          ) : (
            <div className={styles.priceDetailPopover}>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
          )}
        </Spin>
      </div>
      <SDrawerOrModal
        mode="modal"
        title="编辑"
        open={open}
        loading={btnLoding}
        onCancel={() => setOpen(false)}
        // styles={{ body: { padding: '0 15px' } }}
        width={500}
        onOk={onSubmit}
        antdProps={{
          destroyOnClose: true,
        }}
      >
        <div className="budgetPriceEditModal">
          <Form form={form} onValuesChange={spaceChange} labelWrap layout="vertical">
            {skuArgList?.length ? <STitle title={'商品规格'} /> : null}
            {skuArgList?.map((item: any) => {
              if (item.argType === 'INPUT') {
                return (
                  <Form.Item
                    label={item?.argName}
                    name={item?.argCode}
                    rules={[{ required: true, message: '请输入' }]}
                    initialValue={item?.argVal}
                    style={{
                      display:  item.addFlag ? 'none' : 'block',
                    }}
                  >
                    <Input />
                  </Form.Item>
                )
              }
            })}
            {/* 空间规格 */}
            {spaceArgList?.length &&
            form
              .getFieldValue('spaceQuoteBudgetItemList')
              ?.filter((item: any) => item.spaceSpecParamValues?.length)?.length ? (
              <STitle title={'空间规格'} />
            ) : null}
            {spaceArgList?.length ? (
              <Form.List name="spaceQuoteBudgetItemList">
                {fields =>
                  fields.map((field: any, index) => (
                    <Form.Item
                      {...field}
                      name={[index, 'spaceSpecParamValueId']}
                      label={form.getFieldValue('spaceQuoteBudgetItemList')?.[index]?.showName}
                      rules={[
                        {
                          required: form.getFieldValue('spaceQuoteBudgetItemList')?.[index]
                            ?.spaceSpecParamValues?.length
                            ? true
                            : false,
                          message: `${form.getFieldValue('spaceQuoteBudgetItemList')?.[index]
                            ?.showName}不能为空`,
                        },
                      ]}
                      style={{
                        display: form.getFieldValue('spaceQuoteBudgetItemList')?.[index]
                          ?.spaceSpecParamValues?.length
                          ? 'block'
                          : 'none',
                      }}
                    >
                      <Select
                        placeholder={`请输入${form.getFieldValue('spaceQuoteBudgetItemList')?.[
                          index
                        ]?.showName}`}
                        style={{ width: '100%', maxWidth: 460 }}
                        allowClear
                        showSearch
                        optionFilterProp={'name'}
                        options={
                          form.getFieldValue('spaceQuoteBudgetItemList')?.[index]
                            ?.spaceSpecParamValues || []
                        }
                        fieldNames={{
                          label: 'argValue',
                          value: `id`,
                        }}
                      ></Select>
                    </Form.Item>
                  ))
                }
              </Form.List>
            ) : null}
          </Form>
          <p className={styles.warnPtext}>
            若减少卧室个数、卫生间个数可能会丢失已选材数据，请谨慎操作！
          </p>
        </div>
      </SDrawerOrModal>

      <SDrawerOrModal
        mode="drawer"
        title="资金池详情"
        open={poolingOpen}
        loading={poolingOpenLoading}
        onCancel={() => setPoolingOpen(false)}
        // styles={{ body: { padding: '0 15px' } }}
        width={800}
        antdProps={{
          destroyOnClose: true,
          footer: null,
        }}
      >
        <PoolingTable data={poolingData}></PoolingTable>
      </SDrawerOrModal>
    </div>
  )
})
